import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Timeline is populated by the room controller via DOM manipulation
    // This controller handles sorting and any future interactions
  }

  sortCards() {
    // Collect all timeline nodes (match cards wrapped in timeline-node)
    const nodes = Array.from(this.element.querySelectorAll(".timeline-node"))

    // Sort by matched_on date, newest first
    nodes.sort((a, b) => {
      const dateA = a.dataset.matchedOn || ""
      const dateB = b.dataset.matchedOn || ""
      return dateB.localeCompare(dateA)
    })

    // Remove existing year headers and nodes
    this.element.querySelectorAll(".timeline-year").forEach(el => el.remove())
    nodes.forEach(node => node.remove())

    // Re-insert grouped by year
    let currentYear = null
    nodes.forEach(node => {
      const matchedOn = node.dataset.matchedOn || ""
      const year = matchedOn.substring(0, 4)

      if (year && year !== currentYear) {
        currentYear = year
        const yearHeader = document.createElement("div")
        yearHeader.className = "timeline-year relative flex items-center gap-3 py-2"
        yearHeader.dataset.year = year
        yearHeader.innerHTML = `
          <div class="z-10 w-3 h-3 shrink-0 rounded-full bg-indigo-600"></div>
          <span class="text-sm font-bold text-gray-800">${year}</span>
          <div class="flex-1 h-px bg-gray-300"></div>
        `
        this.element.appendChild(yearHeader)
      }

      this.element.appendChild(node)
    })
  }
}
